import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal.js'
import Paging from '../../components/Paging'
import qs from 'qs'
import queryString from 'query-string'
import fp from 'lodash/fp'
import FormDropdown from '../../components/FormDropdown'
import XLSX from 'xlsx'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { extendMoment } from 'moment-range'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ModalHelp from "../../components/ModalHelp";

const normalizeLevelName = (str) => {
    return fp.startCase(str.replace("_", " "))
}

// const yourDate = new Date()
const NewDateStart  = moment().format('YYYY-MM-DD')
const NewDateEnd    = moment().format('YYYY-MM-DD')

class ListsSiswa extends Component {

    constructor() {
        super();
        this.state = {
            dataUsers    : [],
            dataKelas    : [],
            pageCount    : 0,
            currentPage  : 0,
            user_id      : 0,
            kelas_id     : "",
            user_name    : "",
            dateNowStart : NewDateStart,
            dateNowEnd   : NewDateEnd,
            isButtonLoading: false,
            isButtonExport: false,
            dateStart    : moment(),
            dateEnd      : moment(),
			date         : moment(),
            dKelas       : null,
            tableExport : false,
            isLoading    : true,
            tutorial: '',
            isModalHelpShow  : false,
            isModalShow  : false,
            repos: []
        }

        this.handleChange               = this.handleChange.bind(this)
        this.handlePageClick            = this.handlePageClick.bind(this)
        this.handleChangeDatepickerStart   = this.handleChangeDatepickerStart.bind(this);
        this.handleChangeDatepickerEnd     = this.handleChangeDatepickerEnd.bind(this);
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
        this.importFile                     = this.importFile.bind(this);
    }


    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/eZ2ytgl1w9c'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }
    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
            //this.loadExport();
        });
    };

    handleChangeDatepickerStart(e) {
        this.setState({
            dateStart:e,
            dateNowStart:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                //this.loadExport();
                this.loadData();
            })
    }

    handleChangeDatepickerEnd(e) {
        this.setState({
            dateEnd:e,
            dateNowEnd:e.format('YYYY-MM-DD'),
            isLoading:true
        },()=>{
                //this.loadExport();
                this.loadData();
            })
    }

    loadData() {

        let sortirLevel;

        sortirLevel = "siswa"

        this.setState({ isButtonLoading: true });
        this.setState({ isLoading: true })

        const params = qs.stringify({
            page : this.state.currentPage + 1,
            level: sortirLevel,
            cari: this.state.user_name,
            kelas: this.state.kelas_id,
            dateStart: this.state.dateNowStart,
            dateEnd: this.state.dateNowEnd
        })

        axios.post("/reportsiswa?" + params)
            .then(response => {

                const result = response.data
                this.setState({
                    dataUsers  : result.data.data,
                    pageCount  : result.data.last_page,
                    isLoading  : false,
                    isButtonLoading  : false,
                    isButtonExport: false
                })
            })
            .catch((error) => {

                console.log(error)

                this.setState({ isLoading: false })

                Alert.error("Gagal terhubung ke server!")
            })
    }

    importFile() {
        this.setState({ isLoading: true, isButtonLoading:true })

        const params = qs.stringify({
            start: this.state.dateNowStart,
            end: this.state.dateNowEnd
        })

        axios.post("/presensi/getapiback?" + params).then(response => {

            const result = response.data
            if (result.status){
                this.setState({
                    isButtonLoading: false,
                    isLoading: false
                })

                Alert.success(result.info)
            }else{
                this.setState({
                    isButtonLoading: false,
                    isLoading: false
                })

                Alert.error(result.info)
            }


        }).catch((error) => {
            console.log(error)
            this.setState({isButtonLoading:false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    loadDataKelas() {
        this.setState({ isButtonLoading: true });
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key: item.kelas_id,
                    value: item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    componentDidMount() {

        let sortirLevel;

        sortirLevel = "siswa"
        this.loadData()
        this.loadDataKelas()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search ||
            prevState.user_name !== this.state.user_name || prevState.kelas_id !== this.state.kelas_id) {
            this.loadData()
        }
    }

    render () {
        const urlParams = queryString.parse(this.props.location.search);

        let sortirLevel;
        let levelName;
        let kelas;
        let no = 1;

        const momentRange = extendMoment(moment);
        const range = momentRange.range(this.state.dateNowStart,this.state.dateNowEnd);
        const arrayDate = Array.from(range.by('day'));

        kelas = null
        sortirLevel = "siswa"
        levelName = "Siswa"

        return (

            <div className="col-sm-12">

                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <div className="card">
                    <div className="card-header">
                        Data {levelName}
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-6 form-group row">
                                <label className="col-md-12 form-control-label">
                                    <b>Nama</b>
                                </label>
                                <div className="col-md-6">
                                    <input
                                        name="user_name"
                                        type="text"
                                        className="form-control"
                                        placeholder="Ketikkan Nama Pengguna ..."
                                        value={this.state.user_name}
                                        onChange={this.handleChange}
                                        />
                                </div>

                                <div className="col-md-6">
                                    <FormDropdown
                                        items={this.state.dataKelas}
                                        onChange={this.handleChange}
                                        value={this.state.kelas_id.toString()}
                                        name="kelas_id"
                                    />
                                </div>

                            </div>

                            <div className="col-md-6 form-group row">

                                <label className="col-md-12 form-control-label">
                                    <b>Range Tanggal Export Presensi</b>
                                </label>

                                <div className="col-md-4">

                                    <DatePicker
                                        selected={this.state.dateStart}
                                        onChange={this.handleChangeDatepickerStart}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />
                                </div>

                                { sortirLevel === 'siswa'  ? ( "-" ) : " " }

                                <div className="col-md-4">

                                    <DatePicker
                                        selected={this.state.dateEnd}
                                        onChange={this.handleChangeDatepickerEnd}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="form-group row" style={{ marginTop:'-15px' }}>
                            <div className="col-md-6 form-group row">
                                <div className="col-md-3">
                                    <NavLink
                                        style={{width:'125px', height:'35px'}}
                                        to={"/reportpresensi/exportsiswa?cari="+this.state.user_name+"&kelas="+this.state.kelas_id+"&dateStart="+this.state.dateNowStart+"&dateEnd="+this.state.dateNowEnd }
                                        className="btn btn-primary btn-sm"
                                        target="_blank"
                                    >Export Presensi</NavLink>

                                </div>
                                {" "}
                                <div className="col-md-3">
                                    <button
                                        className="btn btn-danger"
                                        style={{width:'125px'}}
                                        disabled={this.state.isButtonLoading && "disabled" && "disabled"}
                                        onClick={this.importFile}>
                                        {this.state.isButtonLoading  ? "Loading.." : "Sync Presensi"}
                                    </button>
                                </div>
                                {" "}
                                <div className="col-md-3">
                                    <NavLink
                                        style={{width:'125px', height:'35px'}}
                                        to={"/reportpresensi/nottaken"}
                                        className="btn btn-primary btn-sm"
                                    >Izin</NavLink>
                                </div>


                            </div>
                        </div>
                        <div>
                        {
                            this.state.isLoading ? (
                                <div className="alert alert-danger" role="alert">
                                    <div className="loader" style={{
                                        width:'20px',
                                        height:'20px',
                                        marginLeft:'0px',
                                        border: '5px solid rgba(0, 0, 0, 0.2)',
                                        borderLeft: '5px solid #000000'
                                    }}></div>
                                    Memuat data..
                                </div>
                            ) : (
                                this.state.dataUsers.length === 0 ? "Data Kosong" : (
                                    <div>
                                        <table  className="table table-striped animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th>Nama Lengkap</th>
                                                    <th>Hadir</th>
                                                    <th>Telat</th>
                                                    <th>Izin</th>
                                                    <th>Alpha</th>
                                                    <th width={190}>Opsi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.dataUsers.map((item) => {

                                                        return (
                                                            <tr key={item.user_id}>
                                                                <td>{item.user_nama}</td>
                                                                <td>{item.tot.hadirWithTelat}</td>
                                                                <td>{item.tot.telat}</td>
                                                                <td>{item.tot.izin}</td>
                                                                <td>{item.tot.alpha}</td>

                                                                <td>
                                                                    <NavLink
                                                                    to={`${this.props.match.url}/view/${item.siswa_id}/${this.state.dateNowStart}/${this.state.dateNowEnd}`}
	                                                                    className="btn btn-secondary btn-sm"
	                                                                >View</NavLink>

                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>

                                        <Paging
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }
                        </div>

                    </div>
                </div>



                </div>


        )
    }
}

export default ListsSiswa;



// WEBPACK FOOTER //
// ./src/views/ReportPresensi/ListsSiswa.js